import { type OperationResponse } from "../../../../common.ts";
import {
  omitPathParameters,
  replacePathParameters,
} from "../../../../utils.ts";
import type { AxiosInstance, AxiosRequestConfig } from "axios";
import type * as Paths from "./index.ts";

export const getGlobalSettingsOperations = (client: AxiosInstance) => {
  const update = (
    parameters: Paths.UpdateGlobalSettings.QueryParameters &
      Paths.UpdateGlobalSettings.PathParameters,
    data?: Paths.UpdateGlobalSettings.RequestBody,
    config?: AxiosRequestConfig,
  ): OperationResponse<Paths.UpdateGlobalSettings.Responses.$200> => {
    const url = "/system/global-settings/update";
    return client.post(replacePathParameters(url, parameters), data, {
      params: omitPathParameters(parameters, url),
      ...config,
    });
  };

  return {
    update,
  };
};
